import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const LS_LANG = "lang";

const normalize = (l) => {
  if (!l) return "en";
  if (l === "zh") return "zh_CN";
  if (l === "ko") return "ko_KR";
  if (l === "vi") return "vi_VN";
  if (l === "ja") return "ja_JP";
  if (l === "en_US") return "en";
  return l;
};

const saved = normalize(localStorage.getItem(LS_LANG) || "en");

const messages = {
  en: require("./lang/en.json"),
  zh_CN: require("./lang/zh_CN.json"),
  ja_JP: require("./lang/ja_JP.json"),
  ko_KR: require("./lang/ko_KR.json"),
  vi_VN: require("./lang/vi_VN.json"),
};

const i18n = new VueI18n({
  locale: saved,
  fallbackLocale: "en",
  silentTranslationWarn: true,
  messages,
});

export default i18n;
export { normalize, LS_LANG };